// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".code_button{width:120px;height:30px;color:#fff;font-size:14px;text-align:center;line-height:30px;background:linear-gradient(315deg,#ff846d,#ff3973);border-radius:4px;cursor:pointer}.code_button.disabled{background:#d4d4d4;cursor:default}", ""]);
// Exports
module.exports = exports;
